import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { arrayAllergies } from './utils/allergies';
import { Alerts } from 'src/app/shared/components/alerts/alert';
import { prepareWord } from 'src/app/shared/functions/generic-methods';
import { Question } from 'src/app/features/medical-record/model/question.model';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'cmp-allergies',
  templateUrl: './allergies.component.html',
  styleUrls: ['./allergies.component.scss']
})
export class AllergiesComponent {

  allergies = arrayAllergies;

  categorySelected: any = this.allergies[0];
  typeSelected: any = this.allergies[0].items[0];

  categoryChecked: any;
  typeChecked: any;

  isFirstQuestionnaire: boolean = false;
  isCategorySelected: boolean = false;
  isTypeSelected: boolean = false;

  filteredCategory: any = this.allergies;
  filteredType: any = this.categorySelected.allergyTypes;

  otherOptionsActivated = false;

  constructor(
    public dialogRef: MatDialogRef<AllergiesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private alerts: Alerts
  ) {

    this.isFirstQuestionnaire = this.data.isFirstQuestionnaire;
  }

  ngOnInit() {

    this.prepareAllergies();
  }


  prepareAllergies() {

    this.data.allergies.forEach((allergy: any) => {

      this.allergies.forEach(item => {

        if (prepareWord(item.item) === prepareWord(allergy.allergyCategory)) {

          item.selected = true;

          item.items.forEach((subItem: any) => {

            if (allergy.allergyTypes.find((type: string) => prepareWord(subItem.item) === prepareWord(type))) {

              subItem.selected = true;
            }
            else {

              subItem.selected = false;
            }
          });
        }
        else {

          !item.items.find((f: any) => f.selected) ? item.selected = false : '';
        }
      });
    });

    const cat = this.allergies.find(f => f.selected);

    this.categorySelected = cat ? cat : '';

    this.categorySelected ? this.typeSelected = this.categorySelected.items.find((f: any) => f.selected) : '';
  }

  clickCategory(category: any, checked: boolean) {

    if (category.item === 'Sem alergia declarada') {

      if (checked) {

        category.selected = category.selected ? false : true;
        this.categoryChecked = category;
        this.categorySelected = this.allergies[0];
        this.filteredType = this.categorySelected.items;

        this.allergies.forEach(item => {

          if (item.item !== category.item || !this.categoryChecked.selected) {

            item.selected = false;
            item.items.forEach((type: any) => { type.selected = false });
          }
        });
      }
    }

    else {

      this.allergies.forEach(item => {

        if (checked) {

          if (item.item === category.item) {

            this.allergies[0].selected = false;
            this.allergies[0].items.forEach((type: any) => { type.selected = false; });

            item.selected = item.selected ? false : true;
            this.categoryChecked = item;
            this.categorySelected = item;

            if (item.selected === false) {

              item.items.forEach((type: any) => {

                type.selected = false;
              });
            }
            else {

              this.filteredType = item.items;
            }
          }
          else {

            if (item.selected === true) {

              !item.items.find((subItem: any) => subItem.selected === true) ? item.selected = false : '';
            }
          }

        }
      });
    }

    if (!checked) {

      const selected = this.allergies.find(item => item.item === category.item);
      selected ? this.categorySelected = selected : '';
      this.filteredType = selected?.items;
    }
  }

  clickType(type: any) {

    this.categorySelected.selected = true;
    if (type.item === 'Outros') {
      this.startOtherOptions();
      return
    }

    if (type.item !== '' && type.type === 'outros' && type.selected === true) {
      const index = this.categorySelected.items.findIndex((i: any) => i.item === type.item && i.type === type.type);
      if (index) this.categorySelected.items.splice(index, 1);
    }

    this.categorySelected.items.forEach((item: any) => {

      if (this.categorySelected.item === 'Sem alergia declarada') {

        if (type.item === item.item) {

          item.selected = item.selected ? false : true;
          this.typeChecked = item;
          this.typeSelected = item;
        }
        else {

          item.selected = false;
        }
      }
      else
        if (item.item === type.item) {

          item.selected = item.selected ? false : true;
          this.typeChecked = item;
          this.typeSelected = item;
        }
    });
  }

  startOtherOptions() {
    if (!this.otherOptionsActivated) {
      this.categorySelected.items.push({
        item: '',
        selected: true,
        type: 'outros'
      });
      this.otherOptionsActivated = true;
      return;
    }
  }

  addOthers(event: any) {

    if (!this.categorySelected.items.find((f: any) => prepareWord(f.item) === prepareWord(event))) {

      this.categorySelected.items[this.categorySelected.items.length - 1].item = event;

      this.categorySelected.items.push({
        item: '',
        selected: true,
        type: 'outros'
      });
    }
    else {

      this.alerts.alertWithOneButton('warning', 'Tipo já existe nas opções listadas', 'O tipo que você digitou já existe na categoria selecionada. Verifique se o mesmo já está selecionado.', 'Ok');
    }
  }

  deleteTypeSelected(type: any, category: any) {

    const index = this.allergies.findIndex(cat => cat.item === category.item);

    this.allergies[index].items.forEach((itemFound: any) => {

      if (itemFound.item === type.item) {
        itemFound.selected = false;
      }
    });

    !this.allergies[index].items.find((item: any) => item.selected) ? this.allergies[index].selected = false : '';
  }

  checkIfCategorySelected() {

    this.isCategorySelected = !this.allergies.find(category => category.selected) ? false : true;
    return this.isCategorySelected;
  }

  checkIfTypeSelected() {

    if (this.isCategorySelected) {

      this.isTypeSelected = !this.categorySelected.items.find((type: any) => type.selected) ? false : true;
      return this.isTypeSelected;
    }

    return false;
  }

  showTitle(category: any) {

    if (category.selected === true && category.items.find((type: any) => type.selected === true)) {

      return category.item;
    }

    return;
  }

  filterAllergiesSelected(arrayAllergies: any) {

    const arrayFiltered: Array<any> = [];

    arrayAllergies.forEach((category: any) => {

      ((category.selected === true)) ? arrayFiltered.push(category) : '';
    });

    return arrayFiltered;

  }

  filterTypesSelected(arrayQuestions: Array<any>) {

    const arrayFiltered: Array<any> = [];

    arrayQuestions.forEach(type => {

      (((type.selected === true) && type.item !== 'Outros')) ? arrayFiltered.push(type) : '';
    });

    return arrayFiltered;
  }

  getSelectedAllergies() {

    const selectedArray: any = [];

    this.allergies.forEach(item => {

      if (item.selected) {

        item.items.forEach((subItem: any) => {

          if (subItem.selected) {

            selectedArray.push(item);
          }
        });
      }
    });

    return selectedArray;
  }

  filterItem(itemTyped: any, field: string) {

    if (itemTyped !== '') {

      if (field === 'category') {

        this.filteredCategory = this.allergies.filter(f => prepareWord(f.item).includes(prepareWord(itemTyped)));
      }
      else {

        this.filteredType = this.categorySelected.items.filter((f: any) => prepareWord(f.item).includes(prepareWord(itemTyped)));
      }
    }
  }

  save() {
    const allergies = this.allergies;
    const allSelected = this.getSelectedAllergies()
    this.checkOthers();
    if (this.checkIfCategorySelected() && this.checkIfTypeSelected()) {

      this.dialogRef.close({ type: 'save', allergies: this.getSelectedAllergies() });
    }
  }

  checkOthers(): void {
    const items = cloneDeep(this.categorySelected.items)
    const notEmptys: any[] = items.filter((i: any) => i.item !== '');

    const removeOtherWithouSelect = notEmptys.filter(i => !(i.type === 'outros'&& i?.selected == false));

    const findOther = removeOtherWithouSelect.some((i: any) => i.type === 'outros' && i.item !== '');
    const othersSelectedIndex = removeOtherWithouSelect.findIndex((i: any) => i.item === 'Outros')

    if (othersSelectedIndex !== -1) {
      if (!findOther) {
        notEmptys[othersSelectedIndex].selected = false;
      } else {
        notEmptys[othersSelectedIndex].selected = true;
      }
    }

    this.categorySelected.items = removeOtherWithouSelect;

  }

  close() {
    this.dialogRef.close({ type: 'cancel' });
  }

}
